export const ClusterManagementStorageKey = 'cluster-management';
